import { client } from '..';
import { Last, TrendingResponse } from '../models/trendingModels';

export const getTrendings = async ({
  queryKey,
  pageParam
}: {
  queryKey: (string | number | undefined)[];
  pageParam: Last | string;
}): Promise<TrendingResponse> => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, limit, location, lastDistance, lastId] = queryKey;
  
  const paramIsNumber = typeof pageParam === 'string'

  const url = `/trendings/scrolling?limit=${limit ?? ''}&location=${paramIsNumber ? '' : location}&lastDistance=${paramIsNumber ? '' : pageParam?.lastDistance}&lastId=${paramIsNumber ? '' : pageParam?.lastId}`;

  const finalUrl = `${url}${paramIsNumber ? `&n=${pageParam}` : ''}`

  const { data } = await client.get(finalUrl);

  return data;
};
